// extracted by mini-css-extract-plugin
module.exports = {"formCard":"styles_formCard__3HR2E","actions":"styles_actions__D5oDP","iconButton":"styles_iconButton__2vc79"};